import { getToken, setToken, clearToken } from './auth'

const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:8080'

export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

// Auth gerektiren endpoint'lerde 401 alındığında bir kez logout tetiklemek için.
// Çoklu paralel istek olduğunda tek redirect — yarış koşulu için flag.
let loggingOut = false
function handleAuthExpired() {
  if (loggingOut) return
  loggingOut = true
  clearToken()
  // /login ve /register'da zaten 401 normaldir (örn. yanlış parola) — orada redirect etme.
  const path = window.location.pathname
  if (path === '/login' || path === '/register' || path.startsWith('/forgot-password') || path.startsWith('/reset-password')) {
    loggingOut = false
    return
  }
  window.location.assign('/login?session_expired=1')
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {}
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((init.headers as Record<string, string>) || {}),
  }
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const res = await fetch(`${API_BASE}${path}`, { ...init, headers })

  // Sliding renewal — backend middleware token ömrü azaldığında yeni JWT'yi
  // X-Renewed-Token header'ında döner. Yakala ve localStorage'a yaz.
  const renewed = res.headers.get('X-Renewed-Token')
  if (renewed) {
    setToken(renewed)
  }

  if (res.status === 401 && token) {
    // Token vardı ama backend geçersiz/expired dedi → otomatik logout.
    handleAuthExpired()
  }

  if (!res.ok) {
    const text = await res.text()
    throw new ApiError(res.status, text || res.statusText)
  }
  if (res.status === 204) return null as T
  return res.json()
}
